<template>
    <Layout>
        <div class="row" v-if="Object.keys(batches).length !== 0">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                        <div class="table-responsive mb-0" style="overflow-x: auto">
                            <table class="table table-centered table-striped">
                                <thead>
                                <tr>
                                    <th>Sl</th>
                                    <th>Training Trade | Batch No</th>
                                    <th>Duration</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(batch, index) in batches" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        <router-link :to="{
                                            name: 'batchTraineesList',
                                            params: { batch_id:  batch.id }}" tag="a" target="_blank">
                                            {{ batch.trade.desc }} | {{ batch.batch_no }}
                                        </router-link>
                                    </td>
                                    <td>{{ batch.duration.desc }}</td>
                                    <td>{{ batch.start_date }}</td>
                                    <td>{{ batch.end_date }}</td>
                                </tr>
                                </tbody>
                            </table>
                            <h5 v-if="batches.length === 0" class="text-center text-secondary">
                                No Data Found
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<script>
    import appConfig from '@src/app.config'
    import Layout from '@layouts/main'
    import PageHeader from '@components/page-header'
    import http from "@state/http";

    export default {
        page: {
            title: 'Batch',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: { Layout, PageHeader },
        data() {
            return {
                title: 'Batch List',
                items: [
                    {
                        text: 'Dashboard',
                        href: '/',
                    },
                    {
                        text: 'Batch',
                        href: '/batch/list',
                    },
                    {
                        text: 'List',
                        active: true,
                    },
                ],
                batches: {},
            }
        },
        mounted() {
            this.getTradeBatches();
        },
        methods: {
            getTradeBatches() {
                let tradeId = this.$route.params.trade_id;

                http.get("api/getTradeBatch/" + tradeId).then(response => {
                    if (!response.error) {
                        this.batches = response.data.batches;
                    }
                });
            },
        },
    }
</script>

